import validator from 'validator';
import { isEmpty } from '../isEmpty';
import { authenticationErrorMessages } from '../../Constants/errorMessages';

export const validateResetPasswordEmailFields = data => {
    let errors = {};
    let fields = { ...data };

    fields.email = !isEmpty(data.email) ? data.email : '';

    if (validator.isEmpty(fields.email)) errors.email = authenticationErrorMessages.EMAIL_REQUIRED;
    if (!validator.isEmail(fields.email)) errors.email = authenticationErrorMessages.ENTER_VALID_EMAIL;

    return {
        errors,
        fields,
        isValidationPassed: isEmpty(errors),
    };
};



// WEBPACK FOOTER //
// ./src/Validation/Authentication/ResetPasswordEmail.js